import * as React from "react";

const SvgTrapezoid = ({ rackColor = "#001D3D" , ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="344"
    height="200.66"
    fill="none"
    viewBox="0 0 120 70"
    {...props}
  >
    <path fill="#D7EAFF" d="m3.571 29.803 112.857-25.35v61.985H3.571z"></path>
    <path
      fill={rackColor}
      fillRule="evenodd"
      d="M0 25.954 120 0v70H0zm115.429 39.484H3.571V29.803L116.43 4.453z"
      clipRule="evenodd"
    ></path>
        <path
      d="M0 25.954 120 0v70H0zm116.429  "
      fill="none"
      stroke="black"
      strokeWidth="0.8"
    />
  </svg>
);

export default SvgTrapezoid;
